import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'


const CostTypeForm = ({
  dataSource: {
    isDisabled = true,
    costTypeId,
    costType,
    amount,
    currency,
    exchangeRate,
    euroValue,
    custValue,
    statValue,
  },
  translate,
  enableFields={}
}) => {
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`costType${costTypeId}`}
            label={translate('COST_TYPE', { ns: ['default', 'valueBuildUp'] })}
            isDisabled={isDisabled}
            labelClass='text-none'
            data={[]}
            value={costType}
            text={costType}
            clearable
            onChange={() => { }}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`amount${costTypeId}`}
            type='number'
            label={translate('AMOUNT', { ns: ['default', 'valueBuildUp'] })}
            value={amount}
            // addThousandsSeperator={true}
            clearInput={false}
            onChange={() => { }}
            onBlur={() => { }}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown
            id={`currency${costTypeId}`}
            label={translate('CURRENCY', { ns: ['default', 'valueBuildUp'] })}
            isDisabled={isDisabled}
            labelClass='text-none'
            data={[]}
            value={currency}
            text={currency}
            clearable
            onChange={() => { }}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`exhgRate${costTypeId}`}
            type='text'
            label={translate('EXCHANGE_RATE', { ns: ['default', 'valueBuildUp'] })}
            value={exchangeRate}
            clearInput={false}
            onChange={() => { }}
            onBlur={() => { }}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`eurVal${costTypeId}`}
            type='text'
            label={translate('EUR_VALUE', { ns: ['default', 'valueBuildUp'] })}
            value={euroValue}
            // addThousandsSeperator={true}
            clearInput={false}
            onChange={() => { }}
            onBlur={() => { }}
            isDisabled={true}
          />
        </Grid.Column>
        {enableFields?.custValue && (
          <Grid.Column
            className={(Number(custValue) > 0 && 'greenBg') || (Number(custValue) < 0 && 'redBg')}
          >
            <InputField
              id={`custVal${costTypeId}`}
              type='text'
              label={translate('CUST_VALUE', { ns: ['default', 'valueBuildUp'] })}
              value={custValue}
              className={(Number(custValue) > 0 && 'greenBg') || (Number(custValue) < 0 && 'redBg')}
              clearInput={false}
              onChange={() => { }}
              onBlur={() => { }}
              isDisabled={true}
            />
          </Grid.Column>
        )}
        <Grid.Column
          className={(Number(statValue) > 0 && 'greenBg') || (Number(statValue) < 0 && 'redBg')}
        >
          <InputField
            id={`statVal${costTypeId}`}
            type='text'
            label={translate('STAT_VALUE', { ns: ['default', 'valueBuildUp'] })}
            className={(Number(statValue) > 0 && 'greenBg') || (Number(statValue) < 0 && 'redBg')}
            value={statValue}
            clearInput={false}
            isDisabled={true}
            onChange={() => { }}
            onBlur={() => { }}
          />
        </Grid.Column>
      </Grid.Row>
    </div>
  )
}

export default React.memo(CostTypeForm)
CostTypeForm.defaultProps = {
  translate: (value) => value,
}